import EditIcon from '@mui/icons-material/Edit'
import Button from '@mui/material/Button'
import { MouseEventHandler } from 'react'

interface Props {
  onClick: MouseEventHandler
}
const EditButton = ({ onClick }: Props) => (
  <Button color="secondary" onClick={onClick}>
    <EditIcon fontSize="small" />
    まとめて結果編集
  </Button>
)

export default EditButton
